import React from 'react'
import { useLocation } from "react-router-dom";
import Letter1 from './Letter1';
import Letter2 from './Letter2';
import Letter3 from './Letter3';
import Letter4 from './Letter4';

const Letter = () => {
    const location = useLocation();
    const lettertype = location?.state ? location.state.lettertype : null;
    const letterno = location?.state ? location.state.index : 0;
    // const letterid = location?.state ? location.state.letterid : '';
    const letterid = location?.state?.letterid || location?.state?.index || '';
    const empcode = location?.state?.emp_code ? location.state.emp_code : sessionStorage.getItem("emp_code");
    return (
        <div>
            {/* {sessionStorage.getItem("letter_type") === "1" ? <LetterHeadPr /> : ""} */}
            {lettertype === "1" ? <Letter1 letterid={letterid} lno={letterno} empcode={empcode} /> : ""}
            {lettertype === "2" ? <Letter2 letterid={letterid} lno={letterno} empcode={empcode} /> : ""}
            {lettertype === "3" ? <Letter3 letterid={letterid} lno={letterno} empcode={empcode} /> : ""}
            {lettertype === "4" ? <Letter4 letterid={letterid} lno={letterno} empcode={empcode} /> : ""}
        </div>
    )
}

export default Letter
